import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Why Us', path: '/why-us' },
    { label: 'Engagement', path: '/engagement' },
  ];

  const handleNavClick = () => setIsOpen(false);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="nav-content">
          {/* Logo */}
          <NavLink to="/" className="logo" onClick={handleNavClick}>
            <img src="/companylogo1.png" alt="CoreNuVate IT" className="logo-image" />
          </NavLink>

          {/* Nav Links */}
          <nav className={`nav ${isOpen ? 'nav-open' : ''}`}>
            {navItems.map(item => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                onClick={handleNavClick}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* CTA */}
          <div className="header-cta">
            <button
              className="btn-contact"
              onClick={() => { navigate('/contact'); setIsOpen(false); }}
            >
              Contact Us
            </button>
          </div>

          {/* Hamburger */}
          <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {isOpen && (
        <div className="mobile-nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              {item.label}
            </NavLink>
          ))}
          <button className="btn-contact-mobile" onClick={() => { navigate('/contact'); setIsOpen(false); }}>
            Contact Us
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;